import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import messages from '@intlify/vite-plugin-vue-i18n/messages'
import VueSmoothScroll from 'vue3-smooth-scroll'

import * as Sentry from "@sentry/vue";

import VueAxios from 'vue-axios'
import axios from 'axios'


const i18n = createI18n({
    legacy: false,
    locale: import.meta.env.VITE_LANGUAGE, // NOTE: nastavení jazyku formuláře
    messages
})



const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://1255dbf96dcbb9024887956d875d4b2d@o4508263390052352.ingest.de.sentry.io/4508263444316240",
    // SDK chytá i globální chyby celé stránky webu (Nette, inline onclick), hlásit jen chyby z bundlu formu
    allowUrls: [/\/plugins\/jakeTradeOrderForm\//],
    beforeSend(event) {
        if (event.exception) {
            const stacktrace = event.exception.values[0]?.stacktrace;
            if (stacktrace && stacktrace.frames) {
                // Ignoruj chyby z Cookiebot nebo jiných specifických knihoven
                const isExternalError = stacktrace.frames.some(frame =>
                        frame.filename.includes('cookiebot.com') //||
                    //frame.filename.includes('@sentry/browser')
                );
                if (isExternalError) {
                    return null; // Zahoď událost
                }
            }
        }
        return event; // Pošli ostatní chyby
    },
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    enabled: process.env.NODE_ENV !== 'development',
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay: Free plán má 50 replays měsíčně, nahrávat jen session s chybou
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
});

app.use(i18n)
app.use(VueAxios, axios)
app.use(VueSmoothScroll, {
    offset: -120,

})
app.mount('#appJakeTrade')


